<template>
  <div :class="{ 'current-filters': filters.length }">
    <ul>
      <li v-for="filter in filters">
        <transition name="fade">
          <div>
            <span>{{ filter.name }}</span>
            <span class="link" @click="removeFilter(filter)"><i class="fa fa-times fa-lg" aria-hidden="true"></i></span>
          </div>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      default: []
    },
  },
  data () {
    return {
    }
  },
  methods: {
    removeFilter ( filter ) {
      this.$emit( 'removeFilter', filter )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.current-filters {
  display: inline-block;
  margin-bottom: 20px;

  ul {
    margin: 0;

    li {
      display: block;
      margin-top: 8px;
      float: left;
      margin-right: 8px;

      @include xl {
        clear: none;
        margin-right: 8px;
      }

      &>div {
        padding: 12px 16px;
        border: 1.5px solid #0B3148;
        border-radius: 21px;
        display: flex;
        align-items: center;
        gap: 10px;
        min-height: 41px;

        span {
          font-size: 12px;
          line-height: 1;
        }

        .link {
          cursor: pointer;
        }
      }
    }
  }
}
</style>